import { HttpClient } from '@angular/common/http';
import { computed, inject, Injectable, signal } from '@angular/core';
import { catchError, map, Observable, of, tap } from 'rxjs';
import { environment } from 'src/environments/environment';

import { ClientConfigModel } from '../models/client-config.model';

/**
 * Holds the runtime configuration served by the API.
 * Loaded once during app initialization so the value is available before any component reads it.
 */
@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private readonly http = inject(HttpClient);

  private readonly config = signal<ClientConfigModel>({ isIdpSelectionActive: false });

  public readonly isIdpSelectionActive = computed(() => this.config().isIdpSelectionActive);

  /**
   * Load the configuration from the API.
   * On failure the safe default (no selection, legacy login) stays in place so the app still boots.
   */
  public load(): Observable<boolean> {
    return this.http.get<ClientConfigModel>(`${environment.api}/config`).pipe(
      tap((config) => {
        this.config.set(config);
      }),
      map(() => true),
      catchError(() => of(false))
    );
  }
}
